/**
 * 로컬 스토리지 유틸리티
 * 암호화 키, 사용자 설정 등 클라이언트 데이터 저장 관리
 */

const PREFIX = 'kalpha_';

/**
 * 채팅방 암호화 키 저장
 */
export function saveRoomKey(roomId: string, key: string): void {
  localStorage.setItem(`${PREFIX}room_key_${roomId}`, key);
}

/**
 * 채팅방 암호화 키 불러오기
 */
export function getRoomKey(roomId: string): string | null {
  return localStorage.getItem(`${PREFIX}room_key_${roomId}`);
}

/**
 * 채팅방 암호화 키 삭제
 */
export function removeRoomKey(roomId: string): void {
  localStorage.removeItem(`${PREFIX}room_key_${roomId}`);
}

/**
 * 사용자 정보 저장
 */
export function saveUserInfo(info: { user_id: string; username: string; display_name: string }): void {
  localStorage.setItem(`${PREFIX}user`, JSON.stringify(info));
}

/**
 * 사용자 정보 불러오기
 */
export function getUserInfo(): { user_id: string; username: string; display_name: string } | null {
  const data = localStorage.getItem(`${PREFIX}user`);
  return data ? JSON.parse(data) : null;
}

/**
 * 사용자 정보 삭제
 */
export function removeUserInfo(): void {
  localStorage.removeItem(`${PREFIX}user`);
}

/**
 * 모든 데이터 초기화 (로그아웃 시)
 */
export function clearAll(): void {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
}
